module.exports = __webpack_public_path__ + "static/media/Interstate-Bold.b3bc25e1.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/Interstate-Bold.woff
// module id = 598
// module chunks = 0